import { render, staticRenderFns } from "./VwaDeviceList.vue?vue&type=template&id=0c068da0&scoped=true&"
import script from "./VwaDeviceList.vue?vue&type=script&lang=ts&"
export * from "./VwaDeviceList.vue?vue&type=script&lang=ts&"
import style0 from "./VwaDeviceList.vue?vue&type=style&index=0&id=0c068da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c068da0",
  null
  
)

export default component.exports